import React, { useCallback, useEffect } from 'react';
import { useToast } from '@ordr-as/umami-react/toast';
import config from '../config';
import { useAlreadyRefreshed, useOutdated, useVersionActions } from '../context/VersionStore';

export const VersionNotifier: React.FC = () => {
  const toast = useToast();
  const outdated = useOutdated();
  const alreadyRefreshed = useAlreadyRefreshed();
  const { acknowledgeRefresh } = useVersionActions();

  const handleRefresh = useCallback(() => {
    acknowledgeRefresh();
    window.location.reload();
  }, [acknowledgeRefresh]);

  useEffect(() => {
    // Only show one toast if (a) outdated, (b) not already shown, (c) in QA or Prod
    if (outdated && !alreadyRefreshed && !toast.exists('updateClient') && ['qa', 'prod'].includes(config.env)) {
      toast.push({
        direction: 'top',
        id: 'updateClient',
        message: <span>Get the latest improvements</span>,
        toastAction: {
          actionLabel: 'Refresh',
          onAction: handleRefresh,
        },
      });
    }
    return () => {
      if (toast.exists('updateClient')) {
        toast.remove('updateClient');
      }
    };
  }, [outdated, toast, handleRefresh, alreadyRefreshed]);

  return null;
};
